import styled from 'styled-components';

export const ScrollContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  scrollbar-width: none;
`;

export const Banner = styled.img`
    width: 100%;
    height: 300px;
    border-radius: 15px;
    overflow: hidden;
    object-fit: cover;
    box-sizing: border-box;
`;

export const Title = styled.h1`
    font-size: 18px;
    line-height: 1.5;
    font-weight: 500;
  color: #1C1C1C; 
`;

export const LabelsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  padding: 5px 10px;
  background-color: #E4E4E7;
  border: 2px solid #FFF;
`;

export const LabelText = styled.span`
  color: #1C1C1C;
  font-size: 12px;
    line-height: 1.5;
  font-weight: 400;
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 1.7; 
  font-weight: 400;
  color: #52525B; 
`;

export const OrgContainer = styled.div`
  padding: 10px 0;
  border-top: 1px solid #E4E4E7;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5px
`;

export const OrgTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const OrgLogo = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 10px;
  object-fit: contain;
`;

export const OrgText = styled.p`
  font-size: 14px;
  line-height: 1.7; 
  font-weight: 600;
  color: #1C1C1C; 
`;

export const OrgDescription = styled.p`
  font-size: 14px;
  line-height: 1.7; 
  font-weight: 400;
  color: #52525B;
  max-width: 100%;
`;

export const AgendaItem = styled.div`
  border: 2px solid #F4F4F5;
  border-radius: 10px;
  width: 100%;
  gap: 8px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const AgendaDateContainer = styled.div`
  background: #FFF;
  padding: 10px;
  min-width: 180px;
  border-radius: 25px 0 0 25px;
  border-right: 15px solid #F4F4F5;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  
  @media (max-width: 567px) {
    flex:1;
    border-right: none;
    align-items: flex-start;
    border-bottom: 1px solid #F4F4F5;
    border-radius: 25px 25px 0 0;
  }
`;

export const AgendaTime = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 4px;
`;

export const AgendaTimeText = styled.span`
  color: #1C1C1C;
  font-size: 12px;
`;

export const AgendaDuraiton = styled.span`
  color: #3F3F46;
  font-size: 14px;
  line-height: 20px;
  font-weight: 300;
`;

export const AgendaTextContainer = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 330px;
  @media (max-width: 567px) {
    min-width: 100%;
  }
`;

export const PrelegentsContainer = styled.div`
  padding-top: 12px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-start;
  border-top: 1px solid #E4E4E7;
  margin-top: 12px;
`;

export const PrelegentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const PrelegentImage = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 10px 0 0 10px;
`;

export const PrelegentTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  height: 64px;
  padding: 12px;
  border-radius: 0 10px 10px 0;
  background: #F4F4F5;
`;

export const PrelegentName = styled.span`
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
`;

export const PrelegentRole = styled.span`
  font-size: 12px;
  font-weight: 400;
    padding-bottom: 10px;
`;
